import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const FbAudience = ({
  height = 24,
  width = 24,
  color = 'currentColor',
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      d="M11.8947 5.6C11.8421 5.55 11.7895 5.5 11.7368 5.5H9.73684V4.8C9.73684 4.65 9.78947 4.5 10 4.5H11.5789C11.6316 4.5 11.7368 4.5 11.7895 4.4C11.7895 4.35 11.8421 4.3 11.8421 4.25V2.25C11.8421 2.1 11.7368 2 11.5789 2H9.31579C6.78947 2 6.57895 4.05 6.57895 4.7V5.5H5.26316C5.10526 5.5 5 5.6 5 5.75V7.75C5 7.9 5.10526 8 5.26316 8H6.57895V13.75C6.57895 13.9 6.68421 14 6.84211 14H9.47368C9.63158 14 9.73684 13.9 9.73684 13.75V8H11.5263C11.6842 8 11.7895 7.9 11.7895 7.8L12 5.8C12 5.7 11.9474 5.65 11.8947 5.6Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
